import './design-system/theme.css'
import './index.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { queryClient, configureApi } from '@watchparty/shared'
import { ThemeProvider } from '@/design-system'
import { AuthProvider } from '@/features/auth'
import { NotificationProvider } from '@/lib/NotificationContext'
import { App } from '@/App'

configureApi(import.meta.env.VITE_API_BASE_URL ?? '')
const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID ?? ''

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <GoogleOAuthProvider clientId={googleClientId}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <NotificationProvider>
              <App />
            </NotificationProvider>
          </AuthProvider>
        </QueryClientProvider>
      </GoogleOAuthProvider>
    </ThemeProvider>
  </React.StrictMode>
)
